import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M8.829 5.775a1.404 1.404 0 0 1 2.342 0l4.321 6.548a1.404 1.404 0 0 1-1.171 2.177H5.679a1.404 1.404 0 0 1-1.171-2.177l4.32-6.548Z" />
  </svg>
);
export default SvgUp;
